var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9176 11.5064H12.1276L11.8476 11.2364C13.0476 9.83636 13.6676 7.92636 13.3276 5.89636C12.8576 3.11636 10.5376 0.896363 7.73762 0.556363C3.50762 0.0363629 -0.0523822 3.59636 0.467618 7.82636C0.807618 10.6264 3.02762 12.9464 5.80762 13.4164C7.83762 13.7564 9.74762 13.1364 11.1476 11.9364L11.4176 12.2164V13.0064L15.6676 17.2564C16.0776 17.6664 16.7476 17.6664 17.1576 17.2564C17.5676 16.8464 17.5676 16.1764 17.1576 15.7664L12.9176 11.5064ZM6.91762 11.5064C4.42762 11.5064 2.41762 9.49636 2.41762 7.00636C2.41762 4.51636 4.42762 2.50636 6.91762 2.50636C9.40762 2.50636 11.4176 4.51636 11.4176 7.00636C11.4176 9.49636 9.40762 11.5064 6.91762 11.5064Z",
    fill: "#9A9AB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.78f907b09f5f24a8cc0bbe2800728540.svg";
export { ForwardRef as ReactComponent };